import formatDateTimeZoned from "./formatDateTimeZoned";
import parseDate from "./parseDate";

const renderDateTimeZoned = (value: unknown, timezone?: string | null) => {
  const dateValue = parseDate(value);

  if (!dateValue) {
    return "-";
  }

  return formatDateTimeZoned(dateValue, timezone);
};

export default renderDateTimeZoned;
